import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useHomeData } from '@/hooks/useHomeData';
import LoadingView from '../common/LoadingView';
import HomeHeader from './HomeHeader';
import RecentRefund from './RecentRefund';
import HomeNotice from './HomeNotice';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { setFilterSeletor } from '@/store/modules/refund';

function HomeContent() {
  const dispatch = useAppDispatch();
  const { data } = useHomeData();

  useEffect(() => {
    dispatch(setFilterSeletor({ startDate: new Date(), endDate: new Date() }));
  }, []);

  return (
    <Container>
      {data ? (
        <>
          <HomeHeader medicalInfo={data} />
          <RecentRefund medicalInfo={data} />
          <HomeNotice medicalNotice={data.notice} />
        </>
      ) : (
        <LoadingView />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 22px 40px 85px 40px;
  @media ${(props) => props.theme.laptop} {
    gap: 24px;
  }
`;

export default HomeContent;
